export const DEFAULT_CITY_INDICATORS = [
  {
    value: "80",
    label: "crianças e adolescentes atendidos",
    description: "",
  },
  {
    value: "+300",
    label: "atendidos",
    description: "",
  },
  {
    value: "+1200",
    label: "pessoas impactadas",
    description: "",
  },
];

const normalizeText = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const getIndicatorSlot = (indicator) => {
  const label = normalizeText(
    `${indicator?.value || ""} ${indicator?.label || ""}`,
  );

  if (label.includes("crianca") || label.includes("adolescente")) return 0;
  if (label.includes("atendid")) return 1;
  if (label.includes("impactad")) return 2;

  return -1;
};

const normalizeKnownIndicatorValue = (value, slot) => {
  const normalizedValue = String(value || "").trim();

  // Corrige o valor legado criado quando dois indicadores foram unidos.
  if (slot === 1 && /^\+?3002$/.test(normalizedValue)) return "+300";

  return normalizedValue;
};

const applyIndicators = (baseItems, indicators) => {
  const normalizedItems = baseItems.map((item, index) => ({
    ...item,
    order: index,
  }));
  const source = Array.isArray(indicators)
    ? [...indicators].sort(
        (a, b) => Number(a?.order || 0) - Number(b?.order || 0),
      )
    : [];
  const explicitOrders = source
    .map((indicator) => Number(indicator?.order))
    .filter((order) => Number.isInteger(order) && order >= 0 && order < 3);
  const hasCompleteOrder = new Set(explicitOrders).size === 3;
  const usedSlots = new Set();
  const unassigned = [];

  source.forEach((indicator) => {
    const explicitOrder = Number(indicator?.order);
    const slot = hasCompleteOrder
      ? explicitOrder
      : getIndicatorSlot(indicator);

    if (
      Number.isInteger(slot) &&
      slot >= 0 &&
      slot < 3 &&
      !usedSlots.has(slot)
    ) {
      normalizedItems[slot] = {
        ...normalizedItems[slot],
        ...indicator,
        value: normalizeKnownIndicatorValue(indicator.value, slot),
        order: slot,
      };
      usedSlots.add(slot);
      return;
    }

    unassigned.push(indicator);
  });

  unassigned.forEach((indicator) => {
    const explicitOrder = Number(indicator?.order);
    const slot =
      Number.isInteger(explicitOrder) &&
      explicitOrder >= 0 &&
      explicitOrder < 3 &&
      !usedSlots.has(explicitOrder)
        ? explicitOrder
        : normalizedItems.findIndex((_, index) => !usedSlots.has(index));
    if (slot < 0) return;

    normalizedItems[slot] = {
      ...normalizedItems[slot],
      ...indicator,
      value: normalizeKnownIndicatorValue(indicator.value, slot),
      order: slot,
    };
    usedSlots.add(slot);
  });

  return normalizedItems;
};

export function normalizeCityIndicators(
  indicators,
  fallbacks = DEFAULT_CITY_INDICATORS,
) {
  const normalizedFallbacks = applyIndicators(
    DEFAULT_CITY_INDICATORS,
    fallbacks,
  );

  return applyIndicators(normalizedFallbacks, indicators);
}
